
import React from 'react';
import './VoiceModelSelectionModal.css';

function VoiceModelSelectionModal({ isOpen, onClose, onSelectModel }) {
  console.log('VoiceModelSelectionModal render:', { isOpen });
  
  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Select Voice Model</h2>
        <button onClick={() => onSelectModel('google')}>Google Cloud TTS</button>
        <button onClick={() => onSelectModel('eleven_labs')}>Eleven Labs</button>
        <button onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
}

export default VoiceModelSelectionModal;
